import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as appReducer from "containers/App/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as foldersReducer from "containers/Folders/reducer";

import GoogleSheetsHome from "components/Next/Google/GoogleSheetsHome";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

class GoogleSheetsHomeContainer extends React.PureComponent {
  render() {
    return <GoogleSheetsHome {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    openExploration: (datasetId, outcomeValue) => dispatch(nextReducer.openExploration(datasetId, outcomeValue)),
    createGoogleSheetsDataset: () => dispatch(homeReducer.createGoogleSheetsDataset())
  };
};

const mapStateToProps = (state, ownProps) => {
  const googleSheetsDataset = homeReducer.getGoogleSheetsDataset(state);
  const datasetId = googleSheetsDataset?.id;

  return {
    datasetId: datasetId,
    folderId: foldersReducer.getSelectedFolder(state),

    googleSheetsData: appReducer.getGoogleSheetsData(state),
    googleSheetsDataset: homeReducer.getGoogleSheetsDataset(state),

    isDatasetsLoading: appReducer.getIsDatasetsLoading(state),

    isExploreReady: homeReducer.getIsExploreReady(state, datasetId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(GoogleSheetsHomeContainer);
